/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_3Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_2_bullets_3 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summarize records: explore the sales sample and the PivotTable guide to compare groups without manually adding every row. Check the source range and totals.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_2_bullets_3 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汇总记录：通过销售示例和数据透视表指南，了解如何按组比较，而无需逐行相加。同时核对源数据范围和合计。`)
};

/**
* | output |
* | --- |
* | "Summarize records: explore the sales sample and the PivotTable guide to compare groups without manually adding every row. Check the source range and totals." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_2_bullets_3 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_2_bullets_3(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_2_bullets_3(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_2_bullets_3 as "gc.search_guides.what_is_gridcraft.sections.2.bullets.3" }